import React from 'react';
import './SlideIn.css';
import classnames from 'classnames';
import Portal from '../Portal/Portal';
import useComponentContext from '../../hooks/useComponentContext';
import CloseBtn from '../CloseBtn/CloseBtn';

interface ISlideInProps {
  open?: any;
  onClose?: (e?: any) => void;
  enableContainer?: boolean;
  containerStyle?: React.CSSProperties;
  containerClassName?: string;
  className?: string;
  style?: React.CSSProperties;
  contentInheritsHeight?: boolean;
  closeBtn?: boolean;
  target?: string;
  contentMaxHeightClassName?: string;
  closeBtnContainerClassName?: string;
}

const SlideIn: React.FC<React.PropsWithChildren<ISlideInProps>> = ({
  open,
  onClose,
  children,
  enableContainer,
  containerStyle,
  containerClassName,
  className,
  style,
  contentInheritsHeight,
  closeBtn,
  closeBtnContainerClassName = '',
  contentMaxHeightClassName = 'max-h-[85vh]',
  target,
}) => {
  const { setModalOpen } = useComponentContext();

  React.useEffect(() => {
    setModalOpen?.(open);
  }, [open]);

  const Container = ({ children }) => {
    return (
      (enableContainer && (
        <div
          className={`bg-white rounded-t-xl lg:rounded-xl p-5 ${containerClassName}`}
          style={containerStyle}
        >
          {children}
        </div>
      )) || <React.Fragment children={children} />
    );
  };

  return (
    <Portal target={target}>
      <div className={classnames('SlideIn')}>
        {open && (
          <div
            className="fixed top-0 left-0 z-20 w-full h-full bg-gray-900 bg-opacity-25"
            onClick={onClose}
          />
        )}
        <div
          style={style}
          className={classnames(
            'SlideIn-content fixed bottom-0 left-0 z-20 w-full lg:h-full lg:flex lg:items-center lg:justify-center',
            className,
            {
              'SlideIn-content-open': open,
            }
          )}
        >
          <Container>
            <div
              className={classnames(
                'w-full max-w-lg mx-auto min-w-[20vw]',
                contentMaxHeightClassName
              )}
              style={
                (contentInheritsHeight && {
                  height: 'inherit',
                }) ||
                undefined
              }
            >
              <div className="relative">
                {closeBtn && (
                  <div
                    className={`absolute top-0 right-0 p-2 ${closeBtnContainerClassName}`}
                  >
                    <CloseBtn onClick={onClose} size="sm" />
                  </div>
                )}
              </div>

              {children}
            </div>
          </Container>
        </div>
      </div>
    </Portal>
  );
};
export default SlideIn;
